import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Card,
  CardHeaderNumber,
  CardContentLine,
} from './MetricsCard';
import * as Price from '../util/Price';
import { AppContext } from '../context/AppContext';
import colors from '../styles/colors';
import { SU_DashboardFilteresTypes, DashboardFiltersSubTypes } from '../util/CustomerFilterEnum';
import { getFilteredSuperadminContacts } from '../util/customersUtil';

export default function TotalCreditActivatedCard({ metrics, timeRange }) {
  const { setApp } = useContext(AppContext);
  const history = useHistory();
  const isNewClickable = metrics?.totalCreditActivatedNew > 0;
  const isReturningClickable = metrics?.totalCreditActivatedRepeat > 0;
  const isReferrersClickable = metrics?.totalCreditActivatedAffiliate > 0;
  const onClickHandler = (subType) => getFilteredSuperadminContacts(setApp, history, {
    type: SU_DashboardFilteresTypes.CreditActivated,
    subType,
    ...timeRange,
  });

  return (
    <Card title="Credit Activated">
      <CardHeaderNumber>{Price.CurrencyFormatter(Price.output(metrics.totalCreditActivated, true))}</CardHeaderNumber>
      <CardContentLine
        left="New Customers"
        right={Price.CurrencyFormatter(Price.output(metrics.totalCreditActivatedNew, true))}
        color={isNewClickable ? colors.seaGreen : colors.grey2}
        onClick={isNewClickable ? () => onClickHandler(DashboardFiltersSubTypes.New) : null}
      />
      <CardContentLine
        left="Returning Customers"
        right={Price.CurrencyFormatter(Price.output(metrics.totalCreditActivatedRepeat, true))}
        color={isReturningClickable ? colors.seaGreen : colors.grey2}
        onClick={isReturningClickable ? () => onClickHandler(DashboardFiltersSubTypes.Returning) : null}
      />
      <CardContentLine
        left="Referrers"
        right={Price.CurrencyFormatter(Price.output(metrics.totalCreditActivatedAffiliate, true))}
        color={isReferrersClickable ? colors.seaGreen : colors.grey2}
        onClick={isReferrersClickable ? () => onClickHandler(DashboardFiltersSubTypes.Referrers) : null}
      />
    </Card>
  );
}
